/* İNÇ → CM gösterimi (Ali 2026-08-04)
   Kural: ABD inç, diğer tüm ülkeler cm.

   ⚠ TASARIM KARARI — hiçbir şeyi bozmamak için:
   · Yalnız EKRANDAKİ YAZI değişir. Varyant değerleri, SKU'lar, sepet, sipariş ve
     baskı hattı HİÇ dokunulmaz — Shopify'a giden veri aynen kalır.
   · Ölçü tabloda YOKSA yazı olduğu gibi bırakılır (sessiz bozulma olmaz).
   · Dönüştürülen düğüme özgün metin `data-in` olarak yazılır (geri almak/denetlemek için).
   · Yalnız ölçüyle ilgili kapsayıcılarda çalışır; ürün açıklaması/başlığı gibi
     serbest metne dokunmaz.                                                        */
(function () {
  if (!window.INS_CM || window.INS_UNIT !== 'cm') return;
  /* Bu magazanin olculeri ZATEN cm ise cevrilecek bir sey yok. Metin
     sniffing'e (asagidaki 'cm' kontrolu) guvenmek yetmiyordu: 59 varyantta
     birim hic yazmiyor ve inc sanilip 2,54 katina sisiyordu. */
  if (window.INS_SIZES_ARE_CM) return;

  var MAP = window.INS_CM, CAP = window.INS_CAP || {};

  /* Ölçüyle ilgili kapsayıcılar — bilinçli olarak dar tutuldu */
  var KAPSAYICI = [
    '.cpdp-panel__size', '.cpdp-options__item', '.cpdp-options__label',
    /* ⚠ Bu üçü ilk sürümde EKSİKTİ: seçenek kartları ve üstteki "Boyut:" satırı
       inç kalıyordu, oysa ölçü rehberi cm oluyordu (Ali ekran görüntüsüyle yakaladı). */
    '.cpdp-options__title', '.cpdp-panel__options-label', '.cpdp-panel__options-current-inline',
    '.cpdp-options__card', '.cpdp-options__head-row',
    '.viz-tab', '#vizVdW',
    '.minicart__item-variant', '.minicart__item-opt',
    '.cart-item__option', '.product-option'
    /* ⚠ Custom ürün editörü (.ip-*) BİLEREK YOK: editörün kendisi hem inç hem cm
       değerini biliyor ve birime göre kendisi seçiyor. Burada da çevirirsek
       "72×46 cm72×46 cm" gibi çift yazı çıkıyor (ölçüldü). */
  ].join(',');

  function anahtar(a, b) {
    var f = function (x) { return String(parseFloat(String(x).replace(',', '.'))); };
    return f(a) + 'x' + f(b);
  }

  /* "35" X 24"" · "43”×27,5”" · "24" x 24" * 2 Pieces" → cm */
  /* ⚠ Sondaki boşluğu YEME: tırnak yoksa \s* boşluğu yutup "72×46 cm* 2 Pieces"
     üretiyordu (ölçüldü). Tırnak/birim VARSA önündeki boşlukla birlikte eşleşir. */
  var RE_CIFT = /(\d+(?:[.,]\d+)?)(?:\s*(?:["“”'']|inç|inch))?\s*[xX×]\s*(\d+(?:[.,]\d+)?)(?:\s*(?:["“”'']|inç|inch))?/g;
  var RE_CAP = /Ø\s*(\d+(?:[.,]\d+)?)\s*(?:["“”'']|inç|inch)?/g;

  function cevir(metin) {
    /* ⚠⚠ 2026-08-11 (Ali bildirdi, SDN-3005 ekran görüntüsü): metin ZATEN cm ise
       DOKUNMA. RE_CIFT'te inç işareti isteğe bağlı olduğu için "80x80 cm" de
       eşleşiyordu; INS_CM["80x80"]="200x200" (80 İNÇ = 200 cm) → sayfada
       "200×200 cm cm" çıkıyordu. Yani TR'nin zaten cm olan ölçüsü bir daha
       cm'e çevriliyor, her ölçü 2,54 katına şişiyordu.
       ⛔ Bu betik yalnız INS_UNIT === 'cm' iken çalışır; ABD mağazası inç
       gösterdiği için ABD ETKİLENMEZ. Türkiye'den bakılan ABD sayfasında
       etiketler '28.5" x 18"' biçiminde, içinde "cm" GEÇMEZ → dönüşüm sürer. */
    if (/cm/i.test(metin)) return null;
    var degisti = false;
    var out = metin.replace(RE_CAP, function (tam, d) {
      var cm = CAP[String(parseFloat(d.replace(',', '.')))];
      if (!cm) return tam;
      degisti = true; return 'Ø ' + cm + ' cm';
    });
    out = out.replace(RE_CIFT, function (tam, a, b) {
      var cm = MAP[anahtar(a, b)];
      if (!cm) return tam;                      // tabloda yoksa DOKUNMA
      degisti = true; return cm.replace('x', '×') + ' cm';
    });
    return degisti ? out : null;
  }

  function isle(kok) {
    var kutular = kok.querySelectorAll ? kok.querySelectorAll(KAPSAYICI) : [];
    for (var i = 0; i < kutular.length; i++) {
      var k = kutular[i];
      var yur = document.createTreeWalker(k, NodeFilter.SHOW_TEXT, null);
      var n, liste = [];
      while ((n = yur.nextNode())) liste.push(n);
      for (var j = 0; j < liste.length; j++) {
        var d = liste[j];
        if (d.__insDone) continue;
        var t = d.nodeValue;
        if (!t || t.length > 120 || !/\d/.test(t)) continue;
        var y = cevir(t);
        if (y === null) continue;
        if (d.parentElement && !d.parentElement.hasAttribute('data-in')) {
          d.parentElement.setAttribute('data-in', t.trim().slice(0, 60));
        }
        d.nodeValue = y;
        d.__insDone = true;
      }
    }
  }

  function calistir() { try { isle(document); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', calistir);
  else calistir();

  /* Sepet çekmecesi, varyant değişimi, ölçü rehberi gibi sonradan gelen içerik */
  var bekle = null;
  new MutationObserver(function () {
    clearTimeout(bekle); bekle = setTimeout(calistir, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
